<template lang='pug'>
  i.svg-icon.svg-icon-feature
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill='#F5D339' d='M89.447,38.862c-0.28-0.933-1.073-1.54-2.054-1.633l-25.935-1.681l-9.614-24.176 c-0.327-0.84-1.213-1.26-2.1-1.307c-0.935,0-1.868,0.42-2.241,1.307L37.89,35.548l-25.766,1.681c-0.98,0.093-1.773,0.7-2.1,1.633 c-0.28,0.887,0,1.913,0.746,2.521l19.838,16.615L24.169,83.2c-0.234,0.888,0.139,1.867,0.886,2.428 c0.793,0.56,1.82,0.606,2.614,0.094l22.076-13.862l21.889,13.862c0.84,0.513,1.867,0.466,2.66-0.094 c0.746-0.561,1.121-1.494,0.887-2.428l-6.44-25.202l20.007-16.615C89.493,40.775,89.774,39.749,89.447,38.862z')
      path(fill='#F2BA1A' d='M88.747,41.383L68.74,57.998l6.44,25.202c0.234,0.934-0.141,1.867-0.887,2.428 c-0.793,0.56-1.82,0.606-2.66,0.094L49.745,71.859V10.065c0.887,0.047,1.772,0.467,2.1,1.307l9.614,24.176l25.935,1.681 c0.98,0.093,1.773,0.7,2.054,1.633C89.774,39.749,89.493,40.775,88.747,41.383z')
      path(fill='#F2BA1A' d='M65.473,46.656c-0.279-0.933-1.119-1.541-2.053-1.633l-8.448-0.514l-3.127-7.888 c-0.327-0.84-1.213-1.26-2.1-1.307c-0.934-0.047-1.868,0.374-2.24,1.307l-3.127,7.888l-8.448,0.514 c-0.934,0.094-1.773,0.7-2.054,1.633c-0.326,0.887,0,1.914,0.7,2.52l6.535,5.415l-2.101,8.168c-0.233,0.934,0.14,1.913,0.887,2.473 c0.793,0.561,1.82,0.606,2.614,0.094l7.234-4.527l7.095,4.527c0.793,0.513,1.819,0.467,2.613-0.094 c0.747-0.56,1.12-1.54,0.887-2.473l-2.1-8.168l6.486-5.415C65.473,48.57,65.754,47.543,65.473,46.656z')
      path(fill='#F18D1B' d='M64.727,49.176l-6.487,5.415l2.101,8.168c0.232,0.934-0.141,1.913-0.887,2.473 c-0.794,0.561-1.82,0.606-2.614,0.094l-7.094-4.527V35.315c0.887,0.047,1.772,0.466,2.1,1.307l3.127,7.888l8.447,0.514 c0.935,0.094,1.774,0.7,2.054,1.633C65.754,47.543,65.473,48.57,64.727,49.176z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
